import { useLocation, useNavigate, useNavigationType } from 'react-router'
import { SetupMFATOTP } from 'mfa'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import { useSetupMFATOTP } from '../../hooks/useSetupMFATOTP'
import { LOGIN_ROOT, SETUP_MFA_ENFORCED } from '../../constants/routes'
import { LEARN_MORE_ABOUT_AUTHENTICATOR_APP } from '../../constants/accountRecoveryLinks'
import {
  APPLE_STORE_BADGE,
  GOOGLE_PLAY_BADGE,
} from '../../constants/accountRecoveryImages'

function SetupMFATOTPWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()
  const isFromSettings = location.state?.isFromSettings ?? false
  const { step, isProcessing, errorCode, registrationData, prepare, finish } =
    useSetupMFATOTP({ isFromSettings })

  return (
    <AccountRecoveryBase.Centered>
      <SetupMFATOTP
        location={location}
        history={{ action: navigationType }}
        step={step}
        isFromSettings={isFromSettings}
        isProcessing={isProcessing}
        errorCode={errorCode}
        registrationData={registrationData}
        rootPath={LOGIN_ROOT}
        settingsPath={SETUP_MFA_ENFORCED}
        learnMoreAboutAuthenticatorAppUrl={LEARN_MORE_ABOUT_AUTHENTICATOR_APP}
        googlePlayBadgeUrl={GOOGLE_PLAY_BADGE}
        appleStoreBadgeUrl={APPLE_STORE_BADGE}
        onCancel={() => navigate(-1)}
        onPrepareRegistration={prepare}
        onFinishRegistration={({ registrationToken, otp }) =>
          finish({ registrationToken, otp })
        }
      />
    </AccountRecoveryBase.Centered>
  )
}

export default SetupMFATOTPWrapper
